import { queryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { CompleteSystemLicenseDto } from '@features/systems/domain/systemLicenses.types';
import { systemLicensesService } from './systemLicensesService';

export const systemLicensesKeys = {
  all: ['systemLicenses'] as const,
  bySystem: (systemId: string) => [...systemLicensesKeys.all, 'system', systemId] as const,
};

export function systemLicensesBySystemIdQueryOptions(systemId: string) {
  return queryOptions<CompleteSystemLicenseDto[], AxiosError>({
    queryKey: systemLicensesKeys.bySystem(systemId),
    queryFn: () => systemLicensesService.listSystemLicenses({
      systemId,
    }).then(sl => sl.systemLicenses),
    enabled: !!systemId,
  });
}
